import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Button,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { Header } from "./Header";
import { useAuth } from "../auth/AuthContext";

export default function Home() {
  const { logout, login, isAuthenticated, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
    } catch (err) {
      // erreur affichée via le contexte d'auth
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <>
      <Header title="Artorama Scanner" />
      <Container fluid>
        {(isAuthenticated && (
          <>
            <Button color="primary" tag={Link} to="/session/create" block>
              Créer une nouvelle session
            </Button>
            <Button color="primary" tag={Link} to="/session" outline block>
              Reprendre une session
            </Button>{" "}
            <Button color="danger" block onClick={() => logout()}>
              Log Out
            </Button>
          </>
        )) || (
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="password">Mot de passe</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </FormGroup>
            {error && <Alert color="danger">{error}</Alert>}
            <Button color="primary" block type="submit" disabled={submitting}>
              Log In
            </Button>
          </Form>
        )}
      </Container>
    </>
  );
}
